export const WRONG_PORTAL_MESSAGE = "You are not permitted to use this portal";
